import {
  CUSTOMERS_REQUEST_FAIL,
  CUSTOMERS_REQUEST_SUCCESS
} from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.customers, action) {
  switch (action.type) {
    case CUSTOMERS_REQUEST_SUCCESS:
      return { ...action.payload };
    case CUSTOMERS_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/customer/customers.reducer.js